import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilesDefaultIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.53 4.47L17.53 0.47C17.39 0.33 17.2 0.25 17 0.25H4C3.04 0.25 2.25 1.04 2.25 2V22C2.25 22.96 3.04 23.75 4 23.75H20C20.96 23.75 21.75 22.96 21.75 22V5C21.75 4.8 21.67 4.61 21.53 4.47ZM20.25 22C20.25 22.14 20.14 22.25 20 22.25H4C3.86 22.25 3.75 22.14 3.75 22V2C3.75 1.86 3.86 1.75 4 1.75H16.69L20.25 5.31V22Z"
        fill={color}
      />
      <path
        d="M17 17.38H7C6.65 17.38 6.38 17.66 6.38 18C6.38 18.34 6.66 18.62 7 18.62H17C17.34 18.62 17.62 18.34 17.62 18C17.62 17.66 17.34 17.38 17 17.38Z"
        fill={color}
      />
      <path
        d="M6.38 13C6.38 13.34 6.66 13.62 7 13.62H17C17.34 13.62 17.62 13.34 17.62 13C17.62 12.66 17.34 12.38 17 12.38H7C6.65 12.38 6.38 12.66 6.38 13Z"
        fill={color}
      />
      <path
        d="M7 8.62H14C14.34 8.62 14.62 8.34 14.62 8C14.62 7.66 14.34 7.38 14 7.38H7C6.65 7.38 6.38 7.66 6.38 8C6.38 8.34 6.66 8.62 7 8.62Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FilesDefaultIcon.displayName = 'FilesDefaultIcon';
